export default __webpack_public_path__ + "images/lb-75479923a75562bb3dbec6b5243f1860.svg";